<button *ngIf="canUse" pButton type="button" icon="pi pi-search" class="p-button-text p-button-rounded us-trigger"
  [pTooltip]="'unifiedSearch.trigger' | t" tooltipPosition="bottom" (click)="open()"></button>

<p-dialog *ngIf="canUse" [(visible)]="visible" [modal]="true" [closable]="true" (onHide)="close()" (onShow)="onDialogShown()"
  [style]="dialogStyle" [breakpoints]="{'660px':'95vw'}" [styleClass]="anchored ? 'us-dialog us-dialog--anchored' : 'us-dialog'" [showHeader]="false"
  [position]="anchored ? 'top' : 'center'" [maskStyleClass]="anchored ? 'us-anchored-mask' : ''" [dismissableMask]="anchored"
  appendTo="body">

  <div class="us-shell">
    <!-- Tapping anywhere on the row (icon, padding) puts the cursor in the box too. -->
    <div class="us-input-row" *ngIf="mode !== 'calculator'" (click)="focusInput()">
      <span class="us-input-icon-badge"><i class="pi pi-search"></i></span>
      <input #usInput pInputText autofocus class="us-input" [(ngModel)]="queryText" (ngModelChange)="onQueryTextChange()"
        (keydown)="onInputKeydown($event)" [placeholder]="'unifiedSearch.placeholder' | t" />
      <span class="us-shortcut-hint">{{ 'unifiedSearch.shortcutHint' | t }}</span>
      <span class="us-close" (click)="$event.stopPropagation(); close()">ESC</span>
    </div>

    <div class="us-calc-header" *ngIf="mode === 'calculator'">
      <span class="us-calc-title"><i class="pi pi-calculator"></i> {{ 'unifiedSearch.mode.calculator' | t }}</span>
      <span class="us-close" (click)="close()">ESC</span>
    </div>

    <div class="us-mode-row">
      <div class="us-mode-selector">
        <button type="button" class="us-mode-btn" *ngFor="let m of availableModes; trackBy: trackByModeValue"
          [class.us-mode-btn--active]="mode === m.value" (click)="setMode(m.value)">
          <i [class]="m.icon"></i>
          <span class="us-mode-label">{{ m.labelKey | t }}</span>
        </button>
      </div>
      <span class="us-auto-resolved" *ngIf="autoResolvedLabelKey">
        {{ 'unifiedSearch.autoInterpreting' | t }} <b>{{ autoResolvedLabelKey | t }}</b>
      </span>
    </div>

    <!-- Inline math (macOS Spotlight-style) — Auto mode only; tap/Enter opens full Calculator
         mode prefilled with this answer, never a silent hijack away from the input mid-typing. -->
    <button type="button" class="us-math-result" *ngIf="mode === 'auto' && autoMathResult !== null"
      (click)="openCalculatorFromMath()">
      <span class="us-math-value">= {{ autoMathResult }}</span>
      <span class="us-math-hint">{{ 'unifiedSearch.mathOpenHint' | t }}</span>
    </button>

    <div class="us-body" [class.us-body--calc]="mode === 'calculator'">
      <app-global-search [embedded]="true" [hidden]="mode === 'calculator' || effectiveMode !== 'records'"></app-global-search>
      <app-quick-search [embedded]="true" [hidden]="mode === 'calculator' || effectiveMode !== 'stock'"
        (calculatorRequested)="onQuickSearchCalculatorRequested($event)"></app-quick-search>

      <div class="us-calc-body" *ngIf="mode === 'calculator'">
        <app-simple-calculator [active]="mode === 'calculator'" [startValue]="calculatorPrefill"
          (closeRequested)="onCalculatorClose()">
        </app-simple-calculator>
      </div>
    </div>
  </div>
</p-dialog>
